import { render, staticRenderFns } from "./list-details.vue?vue&type=template&id=8f016dd8&scoped=true"
import script from "./list-details.vue?vue&type=script&lang=js"
export * from "./list-details.vue?vue&type=script&lang=js"
import style0 from "./list-details.vue?vue&type=style&index=0&id=8f016dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f016dd8",
  null
  
)

export default component.exports